import { styled } from '@uhg-abyss/web/tools/styled';
import { Text } from '@uhg-abyss/web/ui/Text';
import { useContentConfig } from '../hooks';
import { useConsentStatus } from '../hooks/useConsentStatus';

export default function GreetingMessage() {
  const { data: config, loading } = useContentConfig();
  const copy = config?.content?.greetingMessage;
  const { data: sessionDetails } = useConsentStatus();
  const firstName = sessionDetails?.firstName ?? '';

  if (loading || !copy) {
    return (
      <Container>
        <HeroContent>
          <div style={{ padding: '20px', textAlign: 'center' }}>Loading...</div>
        </HeroContent>
      </Container>
    );
  }

  return (
    <Container>
      <HeroContent>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.65306 6.67742C10.0923 6.67742 10.4822 6.95877 10.6211 7.3759L12.1179 11.8712L16.6084 13.3696C17.0251 13.5087 17.3061 13.899 17.3061 14.3387C17.3061 14.7784 17.0251 15.1688 16.6084 15.3078L12.1179 16.8062L10.6211 21.3015C10.4822 21.7186 10.0923 22 9.65306 22C9.21385 22 8.82391 21.7186 8.68502 21.3015L7.1882 16.8062L2.69773 15.3078C2.28105 15.1688 2 14.7784 2 14.3387C2 13.899 2.28105 13.5087 2.69773 13.3696L7.1882 11.8712L8.68502 7.3759C8.82391 6.95877 9.21385 6.67742 9.65306 6.67742Z"
            fill="#F5B700"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M17.8163 2C18.0799 2 18.3138 2.16881 18.3972 2.41909L19.1932 4.80981L21.5814 5.60672C21.8314 5.69015 22 5.92436 22 6.18817C22 6.45198 21.8314 6.6862 21.5814 6.76962L19.1932 7.56653L18.3972 9.95726C18.3138 10.2075 18.0799 10.3763 17.8163 10.3763C17.5528 10.3763 17.3188 10.2075 17.2355 9.95726L16.4394 7.56653L14.0513 6.76962C13.8013 6.6862 13.6327 6.45198 13.6327 6.18817C13.6327 5.92436 13.8013 5.69015 14.0513 5.60672L16.4394 4.80981L17.2355 2.41909C17.3188 2.16881 17.5528 2 17.8163 2Z"
            fill="#F5B700"
          />
        </svg>
        <GreetingText as="h2">
          {copy.greeting}
          {firstName && ` ${firstName}`},
        </GreetingText>
        <GreetingSubText as="p">{copy.subtitle}</GreetingSubText>
        <GreetingDisclaimer>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
          >
            <path
              d="M8.33333 12.5C8.56944 12.5 8.76736 12.4201 8.92708 12.2604C9.08681 12.1007 9.16667 11.9028 9.16667 11.6667V8.33333C9.16667 8.09722 9.08681 7.89931 8.92708 7.73958C8.76736 7.57986 8.56944 7.5 8.33333 7.5C8.09722 7.5 7.89931 7.57986 7.73958 7.73958C7.57986 7.89931 7.5 8.09722 7.5 8.33333V11.6667C7.5 11.9028 7.57986 12.1007 7.73958 12.2604C7.89931 12.4201 8.09722 12.5 8.33333 12.5ZM8.33333 5.83333C8.56944 5.83333 8.76736 5.75347 8.92708 5.59375C9.08681 5.43403 9.16667 5.23611 9.16667 5C9.16667 4.76389 9.08681 4.56597 8.92708 4.40625C8.76736 4.24653 8.56944 4.16667 8.33333 4.16667C8.09722 4.16667 7.89931 4.24653 7.73958 4.40625C7.57986 4.56597 7.5 4.76389 7.5 5C7.5 5.23611 7.57986 5.43403 7.73958 5.59375C7.89931 5.75347 8.09722 5.83333 8.33333 5.83333ZM8.33333 16.6667C7.18056 16.6667 6.09722 16.4479 5.08333 16.0104C4.06944 15.5729 3.1875 14.9792 2.4375 14.2292C1.6875 13.4792 1.09375 12.5972 0.65625 11.5833C0.21875 10.5694 0 9.48611 0 8.33333C0 7.18056 0.21875 6.09722 0.65625 5.08333C1.09375 4.06944 1.6875 3.1875 2.4375 2.4375C3.1875 1.6875 4.06944 1.09375 5.08333 0.65625C6.09722 0.21875 7.18056 0 8.33333 0C9.48611 0 10.5694 0.21875 11.5833 0.65625C12.5972 1.09375 13.4792 1.6875 14.2292 2.4375C14.9792 3.1875 15.5729 4.06944 16.0104 5.08333C16.4479 6.09722 16.6667 7.18056 16.6667 8.33333C16.6667 9.48611 16.4479 10.5694 16.0104 11.5833C15.5729 12.5972 14.9792 13.4792 14.2292 14.2292C13.4792 14.9792 12.5972 15.5729 11.5833 16.0104C10.5694 16.4479 9.48611 16.6667 8.33333 16.6667Z"
              fill="#196ECF"
            />
          </svg>
          {copy.disclaimer}
        </GreetingDisclaimer>
      </HeroContent>
    </Container>
  );
}

const Container = styled('div', {
  backgroundColor: '$core.color.neutral.0',
});

const HeroContent = styled('div', {
  marginTop: '$core.spacing.100',
  paddingLeft: '$core.spacing.400',
  paddingRight: '$core.spacing.400',
  position: 'relative',

  '& > svg': {
    position: 'absolute',
    top: 5,
    left: 0,
    width: 30,
  },
});

const GreetingText = styled(Text, {
  fontSize: '32px !important',
  marginBottom: '$core.spacing.100',
  color: '$core.color.brand.100 !important',
});

const GreetingSubText = styled(Text, {
  fontSize: '16px !important',
  color: '$core.color.brand.100 !important',
  marginBottom: '$core.spacing.100',
  fontFamily: '$web.core.font-family.sf-pro-text-semi-bold !important',
  lineHeight: '$core.line-height.200',
  letterSpacing: '-0.02em',
});

const GreetingDisclaimer = styled('div', {
  fontSize: '14px !important',
  color: '$core.color.neutral.100',
  marginBottom: '$core.spacing.100',
  fontFamily: '$web.core.font-family.sf-pro-text-regular',
  backgroundColor: '$core.color.blue.10',
  border: '1px solid $core.color.blue.20',
  padding: '$core.spacing.200',
  borderRadius: '$core.border-radius.sm',
  paddingLeft: '$core.spacing.600',
  position: 'relative',

  '& > svg': {
    position: 'absolute',
    top: 20,
    left: 15,
    width: 20,
    height: 20,
  },
});
